import { Modal, Button } from "react-bootstrap";
import { DayPicker } from "react-day-picker";
import { format } from "date-fns";
import es from "date-fns/locale/es";
import "react-day-picker/dist/style.css";

import { useToasts } from "react-toast-notifications";

const InventoryExcelDate = ({ showModal, setShowModal, handleAction, dateExcel, setDateExcel }) => {
	const { addToast } = useToasts();

	let footer = <p>Por favor seleccione un día.</p>;
	if (dateExcel) {
		footer = (
			<p>
				Seleccionaste <span style={{ color: "#7fb02f" }}>{format(dateExcel, "dd-MM-y")}</span>.
			</p>
		);
	}

	const handleClose = () => {
		setDateExcel("");
		setShowModal(false);
	};

	const handleConfirm = () => {
		if (!dateExcel) {
			addToast("Seleccione una fecha para descargar el documento.", {
				appearance: "error",
			});
			return;
		}

		setShowModal(false);
		handleAction();
	};

	return (
		<Modal show={showModal} onHide={handleClose} backdrop="static" keyboard={false}>
			<div>
				<Modal.Header closeButton>
					<Modal.Title style={{ fontSize: "16px" }}>Seleccione fecha para exportar</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div style={{ display: "flex", justifyContent: "center" }}>
						<DayPicker
							mode="single"
							locale={es}
							selected={dateExcel}
							onSelect={setDateExcel}
							footer={footer}
							fromYear={2019}
							toYear={2030}
							captionLayout="dropdown"
							modifiersClassNames={{
								selected: "date-excel-selected",
								today: "date-excel-today",
							}}
						/>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button style={{ fontSize: "0.8em" }} variant="danger" onClick={() => handleClose()}>
						CANCELAR
					</Button>
					<Button style={{ fontSize: "0.8em" }} variant="success" onClick={() => handleConfirm()}>
						DESCARGAR
					</Button>
				</Modal.Footer>
			</div>
		</Modal>
	);
};

export default InventoryExcelDate;
